// src/pages/Home/Home.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store/authSlice.js';
import { openAuth } from '../../store/uiSlice.js';

// Импорт хуков
import { useCart } from '../../hooks/useCart.js';
import { useFavorites } from '../../hooks/useFavorites.js';

// Импорт всех готовых компонентов из components/home
import PromoSlider from '../../components/home/PromoSlider.jsx';
import InfiniteStepSlider from '../../components/home/InfiniteStepSlider.jsx';
import CategoryShowcase from '../../components/home/CategoryShowcase.jsx';
import ProductShowcase from '../../components/home/ProductShowcase.jsx';
import TrendingMockupsBlock from '../../components/home/TrendingMockupsBlock.jsx';
import FlexibleMockupPacks from '../../components/home/FlexibleMockupPacks.jsx';
import SubscriptionBlock from '../../components/home/SubscriptionBlock.jsx';
import SplitAccordionBlock from '../../components/home/SplitAccordionBlock.jsx';
import GraphicAssetsShowcase from '../../components/home/GraphicAssetsShowcase.jsx';
import CallToActionBlock from '../../components/home/CallToActionBlock.jsx';

export const Home = () => {
  // Redux
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  // Хуки
  const { addToCart } = useCart();
  const { addToFavorites, removeFromFavorites } = useFavorites();

  const handleLogout = () => {
    dispatch(logout());  // ← изменено с logoutUser на logout
    // 🔑 СТРАНИЦУ ВХОДА БОЛЬШЕ НЕ ОТКРЫВАЕМ (2026-10-29): вход и регистрация
    //    живут в модалке (`AuthModal`). Уход на /login после выхода
    //    выбрасывал человека с той страницы, где он стоял.
    dispatch(openAuth({ mode: 'login' }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    
    if (user) {
      console.log('👤 Данные текущего пользователя:', user);
    }
  }, [user]);

  return (
    <div className="flex flex-col min-h-screen bg-brand-white relative m-auto w-[100%] items-center justify-top text-white overflow-x-hidden">
      <div className="flex-1 w-[100%] flex flex-col items-center">
        <PromoSlider />
        <InfiniteStepSlider />
        <CategoryShowcase />
        <ProductShowcase />
        <TrendingMockupsBlock />
        <FlexibleMockupPacks />
        <SubscriptionBlock />
        <SplitAccordionBlock />
        <GraphicAssetsShowcase />
        <CallToActionBlock />
      </div>
    </div>
  );
};